<template>
  <section> 
    <div id="bar">
      <el-radio-group v-model="conditionType" @change="changeType">
        <el-radio-button label="10">Top 10</el-radio-button>
        <el-radio-button label="20">Top 20</el-radio-button>
        <!-- <el-radio-button label="500">Top 50</el-radio-button> -->
      </el-radio-group>
    </div>
    <div id="chart-container" width="500px"></div>
  </section>
</template>

<style>
  #chart-container{
    position:absolute;
    width: 80%;
    height: 100%;
  }
  #bar{
    padding-left:3%
  }
</style>

<script>
import echarts from 'echarts'
export default {
  name: 'storageRank',
  data() {
    return {
      conditionType: '10',
      tableheight: (window.innerHeight - 220) + 'px',
      myChart: null,
      option: null,
      loading: false
    }
  },
  methods: {
    changeType: function() {
      // 加载数据
      this.$ajax({
        url: 'api/Monitor/GetStorageDataRank?top=' + this.conditionType,
        success: (d, r) => {
          this.refreshChart(d)
        }
      })
    },
    loadChart: function() {
      var dom = document.getElementById('chart-container')
      this.myChart = echarts.init(dom)
      // var app = {}
      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['累计存储总量']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: [
          {
            name: '累计存储总量',
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'insideRight',
                formatter: function(parmas) {
                  if (parmas.value > 1000) {
                    return Math.round(parmas.value / 1024 * 100) / 100 + 'GB'
                  } else {
                    return parmas.value + 'MB'
                  }
                }
              }
            },
            data: []
          }
        ]
      }

      // if (option && typeof option === 'object') {
      //   myChart.setOption(option, true)
      // }
      this.changeType()
    },
    refreshChart: function (d) {
      let option = this.option
      option.yAxis.data.splice(0, option.yAxis.data.length)
      option.series[0].data.splice(0, option.series[0].data.length)
      d.reverse()
      d.forEach((item) => {
        option.yAxis.data.push(item.name)
        option.series[0].data.push({'value': Math.round(item.fileSize / 1024 / 1024 * 100) / 100, 'code': item.code})
      })
      this.myChart.setOption(option)

      this.myChart.on('click', (params) => {
        this.$router.push({name: '存储监控',
          query: {
            'code': params.data.code
          }
        })
      })
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.tableheight = (window.innerHeight - 220) + 'px'
      })()
    }
    setTimeout(this.loadChart(), 1000)
  }
}
</script>